import { useEffect } from 'react';
import { useFormikContext } from 'formik';

interface Props {
  onDirtyChange: (dirty: boolean) => void;
}

/**
 * Mirrors Formik's `dirty` into the vendor settings context
 * (`ctx.setCredentialsDirty`, spec §5.4) and lowers it when the form
 * unmounts — which is how leaving edit mode (form unmounted) clears
 * credential dirtiness without the hook knowing about Formik.
 * Must render inside `<Formik>`.
 */
export const FormikDirtyReporter = ({ onDirtyChange }: Props) => {
  const { dirty } = useFormikContext();
  useEffect(() => {
    onDirtyChange(dirty);
  }, [dirty, onDirtyChange]);
  useEffect(() => () => onDirtyChange(false), [onDirtyChange]);
  return null;
};
